import debounce from "lodash.debounce";
import React, { useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { CryptoContext } from "./../context/CryptoContext";
import { GrPowerReset } from "react-icons/gr";
import { IoSearch } from "react-icons/io5";

const SearchInput = ({ handleSearch }) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  let { searchData, setCoinSearch, setSearchData } = useContext(CryptoContext);

  let handleInput = (e) => {
    e.preventDefault();
    let query = e.target.value;
    setSearchText(query);
    handleSearch(query);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch(searchText);
  };

  const selectCoin = (coin) => {

    setCoinSearch(coin);
    setSearchText("");
    setSearchData();
    navigate('/crypto'); 
  };

  return (
    <>
      <form
        className="w-full md:w-5/5 relative flex items-center font-nunito"
        onSubmit={handleSubmit}
      >
        <input
          type="text"
          name="search"
          onChange={handleInput}
          value={searchText}
          style={{color:'black', height: '30px'}}
          className="w-full rounded bg-gray-200
        placeholder:text-gray-100 pl-2
        required outline-0 focus:border 
        focus:border-green
         "
          placeholder="search here..."
        />
        <button type="submit" className="absolute right-1 cursor-pointer">
          {/* <img src={searchIcon} className="w-full h-auto" alt="search" /> */}
          <IoSearch className="text-green text-lg" />
        </button>
      </form>
      {searchText.length > 0 ? (
        <ul
          className="absolute top-11  w-[90%] h-96 rounded
overflow-x-hidden py-2 bg-navyHover bg-opacity-60 
backdrop-blur-md scrollbar-thin scrollbar-thumb-gray-100 scrollbar-track-gray-200
"
        >
          {searchData ? (
            searchData.map((coin) => {
              return (
                <li
                  className="flex items-center ml-4 my-2 cursor-pointer"
                  key={coin.id}
                  onClick={() => selectCoin(coin.id)}
                >
                  <img
                    className="w-[1rem] h-[1rem] mx-1.5"
                    src={coin.thumb}
                    alt={coin.name}
                  />

                  <span>{coin.name}</span>
                </li>
              );
            })
          ) : (
            <div
              className="w-full h-full flex justify-center items-center
             "
            >
              <div
                className="w-8 h-8 border-4 border-green rounded-full
             border-b-gray-200 animate-spin
             "
                role="status"
              />
              <span className="ml-2">Searching...</span>
            </div>
          )}
        </ul>
      ) : null}
    </>
  );
};


const Search = () => {
  let { getSearchResult } = useContext(CryptoContext);
  let { resetFunction } = useContext(CryptoContext);
  const debounceFunc = debounce(function (val) {
    getSearchResult(val);
  }, 2000);

  return (
    <div className="relative flex m-3">
      <SearchInput handleSearch={debounceFunc} />
      <button className="w-[2rem] ml-4 hover:scale-110 transition-all transition-ease relative" onClick={resetFunction}><GrPowerReset /></button>
    </div>
  );
};

export default Search;

